import { z } from "zod";
import { referenceInfo } from "./fixture-planograms.schemas.js";
import { visionPlanogramResult } from "./vision-planogram.schemas.js";
export const visionResponseQuery = z.object({
    source: z.enum(["accepted", "pending"]).default("accepted"),
});
export const visionResponse = z.object({
    versionId: z.string().uuid(),
    versionNumber: z.number().int().positive().nullable(),
    source: visionResponseQuery.shape.source,
    status: z.union([referenceInfo.shape.status, z.literal("completed")]),
    attemptId: z.string().uuid().nullable(),
    jobId: z.string().uuid().nullable(),
    submittedAt: z.string().nullable(),
    provider: z.string().nullable(),
    response: visionPlanogramResult.nullable(),
    message: z.string().nullable(),
});
//# sourceMappingURL=vision-debug.schemas.js.map